<template>
  <div class="content ht-100v pd-0 learning-home">
    <div class="container-fluid">
      <div class="row pd-l-20">
        <section
          v-if="listCurId > 0 && detailObj.rdy"
          class="ps-container col-xl-2 p-t-md"
          style="border-right: 1px solid rgba(72, 94, 144, 0.16);"
        >
          <nav class="nav nav-sidebar tx-13 m-b-md">
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm"
              >Topic</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.topic }}</span>
            </span>
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm m-t-sm"
              >Meeting ID</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.id }}</span>
            </span>
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm m-t-sm"
              >Status</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.status }}</span>
            </span>
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm m-t-sm"
              >Host email</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.host_email }}</span>
            </span>
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm m-t-sm"
              >Password</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.password }}</span>
            </span>
            <label
              class="tx-sans tx-uppercase tx-medium tx-10 tx-spacing-1 tx-color-03 p-l-sm m-t-sm"
              >Start time</label
            >
            <span class="nav-link">
              <span class="nav-title">{{ detailObj.data.start_time }}</span>
            </span>
          </nav>

          <a @click="endMeeting()" role="button" class="btn btn-xs btn-success"
            >End meeting</a
          >
        </section>
        <div
          :class="`col-xl-${listCurId > 0 ? '7' : '9'} p-t-md p-b-md`"
          style="background: rgb(248, 249, 252);"
        >
          <table class="table table-god table-bordered w-full text-left">
            <thead>
              <tr>
                <th>Meeting name</th>
                <th>Meeting ID</th>
                <th>Created</th>
                <th>Start</th>
                <th>Type</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(m, i) in listObj.meetings" :key="i">
                <td>{{ m.topic }}</td>
                <td>
                  <a href="javascript:void(0)" @click="fetchMeetingDetail(m)">{{
                    m.id
                  }}</a>
                </td>
                <td>{{ m.created_at | moment("YYYY.MM.DD HH:mm, dddd") }}</td>
                <td>{{ m.start_time | moment("YYYY.MM.DD HH:mm, dddd") }}</td>
                <td>{{ m.type }}</td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="col-xl-3 p-t-md"
          style="border-left: 1px solid rgba(72, 94, 144, 0.16); height: calc(100vh - 40px);"
        >
          <form
            v-if="taskModelRdy"
            autocomplete="off"
            class="ivu-form ivu-form-label-top"
          >
            <div class="divider-text">Алхам 1</div>
            <div class="form-group">
              <label class="d-block">API Key</label>
              <div class="ivu-form-item-content">
                <div
                  class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type"
                >
                  <input
                    v-model="taskModel.taskEn"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="d-block">API Secret</label>
              <div class="ivu-form-item-content">
                <div
                  class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type"
                >
                  <input
                    v-model="taskModel.mobile"
                    type="password"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="d-block">Token</label>
              <div class="ivu-form-item-content">
                <div
                  class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type"
                >
                  <input
                    v-model="taskModel.st1"
                    type="password"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <label class="d-block">И-Мэйл</label>
              <div class="ivu-form-item-content">
                <div
                  class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type"
                >
                  <input
                    v-model="taskModel.task"
                    type="text"
                    class="form-control"
                  />
                </div>
              </div>
            </div>
            <div class="form-group">
              <div class="ivu-form-item-content text-center">
                <a @click="saveData()" class="btn btn-success">Хадгалах</a>
              </div>
            </div>
            <div class="divider-text">Алхам 2</div>
            <div class="form-group">
              <label class="d-block">User ID</label>
              <div class="ivu-form-item-content">
                <div
                  class="ivu-input-wrapper ivu-input-wrapper-default ivu-input-type ivu-input-group ivu-input-group-default ivu-input-group-with-append ivu-input-with-search"
                >
                  <div class="input-group">
                    <input
                      v-model="taskModel.phone"
                      type="text"
                      class="form-control"
                      placeholder="User ID"
                      aria-label="User ID"
                      aria-describedby="button-addon2"
                      disabled
                    />
                    <div class="input-group-append">
                      <button
                        @click="updateZoomUserId()"
                        class="btn btn-outline-light"
                        type="button"
                        id="button-addon2"
                      >
                        тохируулах
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
//import { getUserId, getMyToken, meetingList, meetingDetail, meetingEnd } from "@/api/external/zoom";
//import { editGroupSettings } from "@/api/config";
//import { getConfigValueByKey, getConfigIdByKey } from "@/libs/util";
import { request } from "@/api/all";
//import { GetInheritedTask, PostInheritedTask } from "@/api/project";
//import { getCoreList } from "@/api/taskCore";

//import '@/view/modules/learningStudent/home/learning.less';

export default {
  data() {
    return {
      projectId: 0,
      taskModel: {},
      taskModelRdy: false,
      zoomUserMail: "",
      listObj: {
        meetings: []
      },
      listCurId: null,
      detailObj: {
        data: {},
        rdy: false
      }
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      let proj = this.$store.state.app.groupDefaultProjects.filter(
        x => x.objectTypeId == 501
      );
      if (proj.length > 0) {
        this.projectId = proj[0].id;
      }
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "ZoomConfig/GetMyToken" },
        store: this.$store
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          if (res.data.tasks != null && res.data.tasks.length > 0) {
            this.initList();
            this.fetchDetail(res.data.tasks[0].id);
          } else {
            this.fetchDetail(0);
          }
        }
      });
    },
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    fetchDetail(id) {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "GET", url: "Task/GetInherited" },
        store: this.$store,
        params: {
          id: id,
          projectId: this.projectId,
          objectTypeId: 501,
          userId: this.$store.state.user.userId
        }
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.taskModel = res.data.task;
          this.taskModelRdy = true;
        }
      });
    },
    saveData() {
      if (this.taskModel.task != null && this.taskModel.task.length > 0) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        //PostInheritedTask({ model: this.taskModel })

        request({
          api: { method: "POST", url: "Task/PostInherited" },
          store: this.$store,
          data: { model: this.taskModel }
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            if (res.result == 1) {
              this.fetchDetail(res.taskId);
              //this.$Message.success("Амжилттай илгээлээ.");
              this.$bvToast.toast("Амжилттай илгээлээ", {
                title: "Мэдэгдэл",
                autoHideDelay: 500,
                appendToast: true,
                variant: "success",
                toaster: "b-toaster-bottom-left"
              });
            }
          }
        });
      } else {
        this.$Notice.warning("И-Мэйл хаяг оруулна уу.");
      }
    },
    updateZoomUserId() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      //getUserId()
      //console.log(this.taskModel.task)
      request({
        api: { method: "get", url: "zoomConfig/getUserId" },
        store: this.$store,
        params: { mail: this.taskModel.task }
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.taskModel.phone = res.data.id;
          this.saveData();
        }
      });
    },
    initList() {
      this.toggleBodyClass("addClass", "dynamic-locker");
      request({
        api: { method: "get", url: "zoom/meetingList" },
        store: this.$store,
        params: { page: 0, size: 30 }
      }).then(res => {
        this.toggleBodyClass("removeClass", "dynamic-locker");
        if (res != false) {
          this.listObj = res.data;
        }
      });
    },
    fetchMeetingDetail(m) {
      if (this.listCurId != m.id) {
        this.toggleBodyClass("addClass", "dynamic-locker");
        request({
          api: { method: "get", url: "zoom/meetingDetail" },
          store: this.$store,
          params: { meetingId: m.id }
        }).then(res => {
          this.toggleBodyClass("removeClass", "dynamic-locker");
          if (res != false) {
            this.listCurId = m.id;
            this.detailObj.data = res.data;
            this.detailObj.rdy = true;
          }
        });
      } else {
        this.listCurId = null;
        this.detailObj.rdy = false;
      }
    },
    endMeeting() {
      request({
        api: { method: "post", url: "zoom/EndMeeting" },
        store: this.$store,
        data: { meetingId: this.listCurId }
      }).then(res => {
        if (res != false) {
          this.listCurId = null;
          this.detailObj.rdy = false;
        }
      });
    }
  }
};
</script>
